import { render } from "./ChatPage.vue?vue&type=template&id=139e384e&scoped=true&ts=true&lang=pug"
import script from "./ChatPage.vue?vue&type=script&lang=ts"
export * from "./ChatPage.vue?vue&type=script&lang=ts"

import "./ChatPage.vue?vue&type=style&index=0&id=139e384e&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139e384e"]])

export default __exports__